import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { makeGetVisibleEvents, makeGetFirstScoreboard } from 'InPlayOverview/selectors';
import couponFactory from 'InPlayOverview/services/coupon_factory';
import CouponHeader from 'InPlayOverview/components/coupons/coupon_header';

import { withCompetitionContext } from 'InPlayOverview/helpers/competition';

export const CompetitionComponent = (props) => {
  const { couponName, visibleEvents, competition } = props;
  const Coupon = couponFactory(couponName);

  if (!visibleEvents.length) {
    return null;
  }

  return [
    <CouponHeader {...props} />,
    <Coupon coupon={couponName} events={competition.events} />,
  ];
};

CompetitionComponent.propTypes = {
  competition: PropTypes.instanceOf(Object).isRequired,
  headers: PropTypes.instanceOf(Array).isRequired,
  couponName: PropTypes.string.isRequired,
  sport: PropTypes.instanceOf(Object).isRequired,
  visibleEvents: PropTypes.instanceOf(Object).isRequired,
  treeType: PropTypes.string.isRequired,
  firstScoreboard: PropTypes.instanceOf(Object).isRequired,
};

const makeMapStateToProps = () => {
  const getVisibleEvents = makeGetVisibleEvents();
  const getFirstScoreboard = makeGetFirstScoreboard();

  return (state, ownProps) => ({
    visibleEvents: getVisibleEvents(state, ownProps),
    firstScoreboard: getFirstScoreboard(state, ownProps),
    treeType: state.inplay.treeType,
  });
};

export default connect(makeMapStateToProps, null)(withCompetitionContext(CompetitionComponent));
